import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/utils/onboarding/themePackLabels";
const I18n = I18nUtil.createScoped(Translations);
export function localizeThemePackName(name: string): string {
  const names: Record<string, string> = {
    "HK AI": I18n.t("HK AI"),
    "HK AI Models": I18n.t("HK AI Models"),
    "HK AI Compute": I18n.t("HK AI Compute"),
    "HK Robotics": I18n.t("HK Robotics"),
    "US Data Center": I18n.t("US Data Center"),
    "HK AI Photonics": I18n.t("HK AI Photonics"),
    "US AI Photonics": I18n.t("US AI Photonics"),
    "US Robotics": I18n.t("US Robotics"),
    "US Nuclear": I18n.t("US Nuclear"),
    "US Oil & Energy": I18n.t("US Oil & Energy"),
  };
  return names[name] ?? name;
}
